/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbContratFormateurGridDto } from './FcbContratFormateurGridDto';
import {
    FcbContratFormateurGridDtoFromJSON,
    FcbContratFormateurGridDtoFromJSONTyped,
    FcbContratFormateurGridDtoToJSON,
} from './FcbContratFormateurGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbContratFormateurGridDtoPaginatedResults
 */
export interface FcbContratFormateurGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbContratFormateurGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbContratFormateurGridDto>}
     * @memberof FcbContratFormateurGridDtoPaginatedResults
     */
    results?: Array<FcbContratFormateurGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbContratFormateurGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbContratFormateurGridDtoPaginatedResults interface.
 */
export function instanceOfFcbContratFormateurGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbContratFormateurGridDtoPaginatedResultsFromJSON(json: any): FcbContratFormateurGridDtoPaginatedResults {
    return FcbContratFormateurGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbContratFormateurGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbContratFormateurGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbContratFormateurGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbContratFormateurGridDtoPaginatedResultsToJSON(value?: FcbContratFormateurGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbContratFormateurGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

